import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-412">
      <div className="max-w-5xl mx-auto" data-id="element-413">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-414">
          Lo que <span className="text-[#FFD700]" data-id="element-415">recibís</span>
        </h2>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-416">
          <div className="bg-black border border-[#FFD700]/30 rounded-2xl p-6" data-id="element-417">
            <h3 className="text-[#FFD700] text-xl font-black mb-5" data-id="element-418">
              🎹 LOS 6 TOMOS
            </h3>
            <div className="space-y-4" data-id="element-419">
              <div className="flex items-center gap-3 text-white" data-id="element-420">
                <span className="text-xl" data-id="element-421">🟢</span>
                <div className="flex-1" data-id="element-422">
                  <span className="font-bold" data-id="element-423">
                    Tomo 1 — El Despertar Musical · Nivel Inicial (4-7 años):
                  </span>
                  <span className="text-gray-300" data-id="element-424">
                    {' '}
                    Exploración del instrumento · Pulso y figuras básicas ·
                    DO-RE-MI · Coordinación básica · Primera canción completa
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-425">
                <span className="text-xl" data-id="element-426">🟡</span>
                <div className="flex-1" data-id="element-427">
                  <span className="font-bold" data-id="element-428">
                    Tomo 2 — El Mundo de las Notas · Nivel Elemental (8-12
                    años):
                  </span>
                  <span className="text-gray-300" data-id="element-429">
                    {' '}
                    Escala de Do Mayor · Clave de Fa · Corcheas y puntillo ·
                    Compás 3/4 · Primera pieza con ambas manos
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-430">
                <span className="text-xl" data-id="element-431">🟠</span>
                <div className="flex-1" data-id="element-432">
                  <span className="font-bold" data-id="element-433">
                    Tomo 3 — La Armonía Comienza · Nivel Intermedio I:
                  </span>
                  <span className="text-gray-300" data-id="element-434">
                    {' '}
                    Escalas Sol Mayor y Fa Mayor · Acordes triadas I-IV-V-I ·
                    Pedal de resonancia · Arpegio y melodía cantabile · Nocturno
                    Simple
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-435">
                <span className="text-xl" data-id="element-436">🔴</span>
                <div className="flex-1" data-id="element-437">
                  <span className="font-bold" data-id="element-438">
                    Tomo 4 — La Técnica se Profundiza · Nivel Intermedio II:
                  </span>
                  <span className="text-gray-300" data-id="element-439">
                    {' '}
                    Extensiones y saltos · Tonalidades menores · Dinámica pp-ff
                    · Repertorio clásico Beethoven y Mozart · Primera pieza de
                    agilidad técnica
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-440">
                <span className="text-xl" data-id="element-441">🟣</span>
                <div className="flex-1" data-id="element-442">
                  <span className="font-bold" data-id="element-443">
                    Tomo 5 — El Pianista Avanzado · Nivel Avanzado I:
                  </span>
                  <span className="text-gray-300" data-id="element-444">
                    {' '}
                    Arpegios de 2 octavas · Los tres pedales · Escalas con
                    alteraciones · Estudios de Czerny · Pieza de concierto
                    Burgmüller
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-445">
                <span className="text-xl" data-id="element-446">⭐</span>
                <div className="flex-1" data-id="element-447">
                  <span className="font-bold" data-id="element-448">
                    Tomo 6 — El Alumno Deja de Ser Alumno · Nivel Maestría:
                  </span>
                  <span className="text-gray-300" data-id="element-449">
                    {' '}
                    Interpretación emocional · Cifrado americano · Preparación
                    de exámenes · Gestión de conciertos · Composición propia ·
                    Recital de graduación
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#FFD700]/5 border border-[#FFD700]/30 rounded-2xl p-8 text-center" data-id="element-450">
          <h3 className="text-[#FFD700] text-xl font-black mb-6" data-id="element-451">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-452">
            <div className="flex items-start gap-2 text-left" data-id="element-453">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-454">✅</span>
              <span className="text-white text-sm" data-id="element-455">
                Planificador semanal completo listo para usar en clase
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-456">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-457">✅</span>
              <span className="text-white text-sm" data-id="element-458">
                Clases estructuradas con objetivo, actividad, variantes por
                nivel y tarea
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-459">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-460">✅</span>
              <span className="text-white text-sm" data-id="element-461">
                Sistema de niveles con ritmos Lento / Estándar / Rápido 🐢🚶🏃
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-462">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-463">✅</span>
              <span className="text-white text-sm" data-id="element-464">
                Evaluación diagnóstica + evaluaciones por tomo con criterios de
                corrección
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-465">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-466">✅</span>
              <span className="text-white text-sm" data-id="element-467">
                Rúbricas completas con escala de 1 a 4 para cada habilidad
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-468">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-469">✅</span>
              <span className="text-white text-sm" data-id="element-470">
                Fichas de seguimiento mensual por alumno
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-471">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-472">✅</span>
              <span className="text-white text-sm" data-id="element-473">
                Piezas originales ProfePack® listas para tocar en clase
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-474">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-475">✅</span>
              <span className="text-white text-sm" data-id="element-476">
                Checklist de egreso por tomo (¿está listo para avanzar?)
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-477">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-478">✅</span>
              <span className="text-white text-sm" data-id="element-479">
                Diplomas de nivel imprimibles para el alumno
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-480">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-481">✅</span>
              <span className="text-white text-sm" data-id="element-482">
                100% adaptado a la realidad del profe de piano argentino
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}